export default {
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 0.125,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: true,
  /**
   * @description api请求基础路径
   */
  /**
   baseUrl: {
     dev: 'https://www.easy-mock.com/mock/5add9213ce4d0e69998a6f51/iview-admin/',
     pro: 'https://produce.com'
   },
   */
  baseUrl: '//wxtest.aukeyit.com/auth',
  // 监控
  baseMonitorUrl: '//wxtest.aukeyit.com/monitor',
  // 持续发布 baseUrl
  baseDeployUrl: '//wxtest.aukeyit.com/deploy',
  // 操作中心
  baseOpsCenterUrl: '//wxtest.aukeyit.com/opscenter',
  // 跳板机 baseUrl
  baseSpringBoardUrl: '//wxtest.aukeyit.com/springboard',
  // 资产管理
  baseCMDBUrl: '//wxtest.aukeyit.com/cmdb',
  // database baseUrl
  baseDBUrl: '//wxtest.aukeyit.com/database',
  // 日志平台 baseUrl
  baseLogUrl: '//wxtest.aukeyit.com/elk',
  // 私有云
  basePrivateCloudUrl: '//wxtest.aukeyit.com/cloud',
  // 容器云 baseUrl
  baseCloudUrl: '//wxtest.aukeyit.com/docker',
  // Dashboard baseUrl
  baseDashboardUrl: '//wxtest.aukeyit.com/dashboard',
  baseNetworkUrl: '//wxtest.aukeyit.com/network',

  // 工作流
  baseWorkflowUrl: '//wxtest.aukeyit.com/workflow',
  // 第三方工具
  baseToolsUrl: '//wxtest.aukeyit.com/tools',

  // 容器管理
  baseContainerUrl: '//wxtest.aukeyit.com/container',

  // Jenkins url
  jenkinsUrl: '//10.1.2.175:8089',
  // guacamole url
  guacamoleUrl: '//wxtest.aukeyit.com/guacamole',
  // saltapiBaseUrl
  saltapiBaseUrl: '//10.1.2.175:8008',
  // WS Message Url
  wsMessageUrl: 'wss://wxtest.aukeyit.com/websocket',

  workSheetApi: '//wxtest.aukeyit.com/worksheet',

  // 备份存储
  backupStorageApi: '//wxtest.aukeyit.com/backup-storage',

  // S3
  s3Api: '//wxtest.aukeyit.com/s3',
  troopApi: '//wxtest.aukeyit.com/troop_service',
  // sso url
  ssoDomain: '//sso.aukeyit.com',
  // devops url
  opsDomain: '//wxtest.aukeyit.com',

  ssoEnabled: false,

  // 企业微信应用ID
  wxAgentId: '1000014',

  /**
   * @description 默认打开的首页的路由name值，默认为home
   */

  homeName: 'home',
  /**
   * @description 登录页的name和path
   */
  LOGIN_PAGE_NAME: 'login',
  LOGIN_PAGE_PATH: '/login',

  /**
   * @description 需要加载的插件
   */

  plugin: {
    'error-store': {
      showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: false // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  }
}
